import { createBrowserRouter } from 'react-router-dom';
import { DashboardScheduleScreen } from 'src/features/home/pages/DashboardSchedule/DashboardScheduleScreen';
import { ForgotPasswordScreen } from 'src/features/auth/pages/ForgotPasswordScreen';
import { LoginScreen } from '../features/auth/pages/LoginScreen';
import { RegisterNewScreen } from '../features/auth/pages/RegisterNewScreen';
import { RootAuth } from 'src/features/auth/pages/RootAuth';
import { RootHome } from 'src/features/home/pages/RootHome/RootHome';
import routes from './routes';
import { DashboardClinicsScreen } from 'src/features/clinics/pages/DashboardClinicsScreen/DashboardClinicsScreen';
import { ClinicUsersScreen } from 'src/features/clinics/pages/ClinicUsersScreen/ClinicUsersScreen';
import { EditClinicScreen } from 'src/features/clinics/pages/EditClinicScreen/EditClinicScreen';
import { DashboardDraftsScreen } from 'src/features/drafts/pages/DashboardDraftsScreen/DashboardDraftsScreen';
import { Logout } from 'src/features/auth/pages/Logout';
import { checkAuthLoader } from 'src/features/auth/utils/auth';
import { NewClinicScreen } from 'src/features/clinics/pages/NewClinicScreen/NewClinicScreen';
import { RegisterScreen } from 'src/features/auth/pages/RegisterScreen';
import { ProfileScreen } from 'src/features/user/pages/ProfileScreen';
import { EditProfileScreen } from 'src/features/user/pages/EditProfileScreen';
import { ConfigsScreen } from 'src/features/user/pages/ConfigsScreen';

const router = createBrowserRouter([
  {
    path: routes.auth,
    element: <RootAuth />,
    children: [
      { path: routes.auth_login, element: <LoginScreen /> },
      { path: routes.auth_register, element: <RegisterScreen /> },
      { path: routes.auth_register_new, element: <RegisterNewScreen /> },
      { path: routes.auth_forgotPassword, element: <ForgotPasswordScreen /> },
    ],
  },
  {
    path: routes.home,
    element: <RootHome />,
    loader: checkAuthLoader,
    children: [
      { path: routes.home, element: <DashboardScheduleScreen /> },
      { path: routes.home_schedule, element: <DashboardScheduleScreen /> },
      { path: routes.home_prescriptions, element: <DashboardScheduleScreen /> },
      { path: routes.home_patients, element: <DashboardScheduleScreen /> },
      { path: routes.clinics, element: <DashboardClinicsScreen /> },
      { path: routes.clinics_new, element: <NewClinicScreen /> },
      { path: routes.clinics_clinicId, element: <ClinicUsersScreen /> },
      { path: routes.clinics_clinicId_edit, element: <EditClinicScreen /> },
      { path: routes.drafts, element: <DashboardDraftsScreen /> },
      { path: routes.profile, element: <ProfileScreen /> },
      { path: routes.profile_edit, element: <EditProfileScreen /> },
      { path: routes.profile_configs, element: <ConfigsScreen /> },
    ],
  },
  { path: routes.logout, element: <Logout /> },
]);

export default router;
